module.exports = __webpack_public_path__ + "assets/702d6fe6be472384377c7b11e84990f8.mp3";